import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

export const MobileSheetStyle = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: ${theme.whiteText2};
  overflow-y: scroll;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.lightBlack};
  z-index: 1000;
`;

export const DrawerPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 540px;
  background: ${theme.whiteText2};
  z-index: 1001;
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.3s ease-out;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: ${theme.whiteText};
`;

export const DrawerTitle = styled.h2`
  font-size: ${fontSize.font20};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const DrawerContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 24px 24px;
`;

export const DrawerFAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DrawerFAQItem = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  padding: 16px;
`;

export const DrawerFAQButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const DrawerQuestionText = styled.span`
  flex: 1;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.semiBold};
  color: ${theme.blackText};
  margin-right: 12px;
`;

export const DrawerAnswerText = styled.p`
  margin: 12px 0 0;
  font-size: ${fontSize.font14};
  color: ${theme.greyText3};
  line-height: 1.6;
`;

export const DrawerChevronWrapper = styled.span<{ $isExpanded: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "rotate(180deg)" : "rotate(0)"};
  color: ${theme.lightGreyText};
`;

export const EmptyState = styled.p`
  font-size: ${fontSize.font14};
  color: ${theme.greyText};
  text-align: center;
  padding: 40px 0;
`;
